import { NoResultsIllustration } from "@kaltura/mediaspace-shared-ui";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { NoResultsScreen } from "./styled-components";

export interface EmptyRecycleBinProps {
    retentionDays: number;
}

/**
 * EmptyRecycleBin component - displays a view of empty recycle bin list
 */
export const EmptyRecycleBin = ({ retentionDays }: EmptyRecycleBinProps) => {
    return (
        <NoResultsScreen
            title={translate("The recycle bin is empty")}
            text={translate("Items in the recycle bin will be automatically deleted after %1 days.", [retentionDays])}
            image={<NoResultsIllustration />}
        />
    );
};
